import { useState } from "react";
import Typewriter from "typewriter-effect";
import { Sparkles } from "lucide-react";
import { Spinner } from "../Spinner";

export function AiFreeTextInputCard({
  label,
  placeholder,
  loadingPhrases,
  onGenerate,
}) {
  const [text, setText] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const handleGenerate = async () => {
    setIsGenerating(true);
    setError(null);

    try {
      await onGenerate(text);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Couldn't generate suggestions from that text. Please try again.",
      );
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 mb-7">
      <label className="block text-sm font-medium text-gray-900 mb-2">
        {label}
      </label>

      {isGenerating ? (
        <div className="flex flex-col items-center justify-center gap-3 py-6">
          <Spinner size="lg" className="text-gray-900" />
          <div className="text-sm font-medium text-gray-600 min-h-[20px] text-center">
            <Typewriter
              onInit={(typewriter) => {
                typewriter.pauseFor(1800).deleteAll().start();
              }}
              options={{
                autoStart: true,
                loop: true,
                strings: loadingPhrases,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
            maxLength={1000}
            placeholder={placeholder}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleGenerate}
              disabled={!text.trim()}
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50"
            >
              <Sparkles className="w-4 h-4" />
              Suggest meals
            </button>
          </div>
        </>
      )}
    </div>
  );
}
